import Vue from "vue";
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations';

if (window?.App?.sentryDSN) {
    console.log('Initiating sentry...')
    Sentry.init({
        Vue: Vue,
        dsn: window.App.sentryDSN,
        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true,
            }),
        ],
        environment: process.env.NODE_ENV
    });
}
